import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import {HashLoader} from "react-spinners"
;

export default function Back_Drop({state}) {
  const [open, setOpen] = React.useState(false);
  


  return (
    <div>
     
      <Backdrop
        sx={{ color: 'lightgray', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={state}
     
      >
<HashLoader  />
      </Backdrop>
    </div>
  );
}